import PropTypes from "prop-types";
import React from 'react';
import '../../container/Testimonial/TestCss.css'

// import ReactStars from "react-rating-stars-component";


const TestimonialBox = ({ data }) => {
    return (

        <div className="container" >
            <div className="row" style={{marginBottom:'10px'}}>
                    <div className="col"   >
                            <div id="marginNew" className="static-testimonial  mb-6" style={{ height:'24rem',position:'relative'}}>
                        
                        <div className="author-info" style={{position:'absolute',top:'50%',left:'0',transform:'translateY(-50%)',padding:'0 20px'}}>
 

                            {/* <span style={{fontSize:'20px'}}>⭐️⭐️⭐️⭐️⭐️</span> */}
                            <span style={{display:'flex',justifyContent:'center'}}>
                                <img style={{width:'55%'}} src="images/imageTrails/Home/Stars.jpg"/>
                            </span>
                            {/* <span style={{display:'flex',justifyContent:'center',position:'relative',top:'-3rem'}}> 
                               <span className="starBack" style={{fontSize:'25px'}}>
                                <span className="fa fa-star checked blue" ></span>
                                <span className="fa fa-star checked blue"></span>
                                <span className="fa fa-star checked blue"></span>
                                <span className="fa fa-star checked blue"></span>
                                <span className="fa fa-star checked blue"></span>
                            </span>
                            <span className="starTop" style={{fontSize:'23.5px'}}>
                                <span className="fa fa-star checked "></span>
                                <span className="fa fa-star checked "></span>
                                <span className="fa fa-star checked "></span>
                                <span className="fa fa-star checked "></span>
                                <span className="fa fa-star checked "></span>
                            </span>
                            </span> */}


                       
                        <div className="testimonial-content" style={{marginBottom:'0px'}}>
                            <p style={{margin:'10px 0px 0px 0px', fontSize:'15px'}}>{data.desc}</p>
                        </div>
                        
                            
                          
                            
                             
                            <div className="cite">
                                <span className="position"  style={{margin:'10px 0',color:'black'}}> - {data.position},  <span className=" " style={{display:'inline', fontWeight:'800'}}>{data.name}</span ></span>
                            </div>
                               
                               
                                </div>

                             
                      
                    </div>
                </div>

              
            </div>
        </div>









    //    <div className="container">
    //        <div className="row">
    //            <div className="col-4">
    //            <div className="card" style={{width: "18rem", height:'17rem', border:'solid black 1px'}}>
    //                 <div className="card-body" >
    //                 <h5 className="card-title mb-4">{data.heading}</h5>
    //                     <h6 className="card-subtitle mb-4 ">{data.name}</h6>
    //                     <h6 className="card-subtitle mb-4 ">{data.testimonial}</h6>
    //                     <h6 className="card-subtitle mb-4 card-subtitle mb-2 ">{data.position}</h6>
    //                     {/* <a href="#" className="card-link">Card link</a>
    //                     <a href="#" className="card-link">Another link</a> */}
    //                 </div>
    //             </div>
                 
    //            </div>
    //            <div className="col-4">
    //            <div className="card" style={{width: "18rem", height:'17rem',border:'solid black 1px'}}>
    //                 <div className="card-body">
    //                 <h5 className="card-title mb-4">{data.heading}</h5>
    //                     <h6 className="card-subtitle mb-4 ">{data.name}</h6>
    //                     <h6 className="card-subtitle mb-4 ">{data.testimonial}</h6>
    //                     <h6 className="card-subtitle mb-4 card-subtitle mb-2 ">{data.position}</h6>
    //                 </div>
    //             </div>
    //                </div>
    //                <div className="col-4">
    //                <div className="card" style={{width: "18rem",height:'17rem',border:'solid black 1px'}}>
    //                 <div className="card-body">
    //                 <h5 className="card-title mb-4">{data.heading}</h5>
    //                     <h6 className="card-subtitle mb-4 ">{data.name}</h6>
    //                     <h6 className="card-subtitle mb-4 ">{data.testimonial}</h6>
    //                     <h6 className="card-subtitle mb-4 card-subtitle mb-2 ">{data.position}</h6>
    //                 </div>
    //             </div>  
    //                </div>
    //        </div>
    //    </div>
    )
}

TestimonialBox.propTypes = {
    data: PropTypes.object
};

export default TestimonialBox;
